import { Navigate, useLocation } from 'react-router-dom';

/** Old /agency/jobs URLs land on /agency/campaigns, keeping slug and query. */
export default function AgencyJobsRedirect() {
  const location = useLocation();
  const to =
    location.pathname.replace(/^\/agency\/jobs/, '/agency/campaigns') + location.search + location.hash;
  return <Navigate to={to} replace />;
}
